import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Button } from 'semantic-ui-react';
import ThemeColorSetting from '../../constants/themeColor';
import zhTrialBanner from '../../assets/home/zhTrialBanner.png';
import enTrialBanner from '../../assets/home/enTrialBanner.png';

const TrialBanner = {
  zh : zhTrialBanner,
  en : enTrialBanner
}

const styles = {
  coverContainer : {
    backgroundSize: 'cover',
    backgroundPosition : 'center',
    height : '80vh',
  },
  headerWrapper : {
    display : 'flex' ,
    flexDirection : 'column',
    alignItems : 'center' ,
    justifyContent : 'center'
  },
  header : {
    color : 'white',
    fontSize : '9vh',
    textShadow: '2px 2px'+ThemeColorSetting.black,
    textAlign : 'center'
  },
  subheader : {
    color : 'white',
    fontSize : '8vh',
    textShadow: '2px 2px'+ThemeColorSetting.black
  },
  appliedButton : {
    backgroundColor : ThemeColorSetting.red,
    color : 'white' ,
  }
}

class TrialPitch extends Component {
  componentDidMount(){
    const { mixpanel } = this.props;
    mixpanel.track_links("#freetrial", "Pitch Page", { action : 'apply free trial' });
  }
  render() {
    const { string , locale } = this.props;
    return(
      <Grid.Row style={{ backgroundImage : 'linear-gradient(rgba(255,255,255,0.4),rgba(255,255,255,0.4)),url(' + TrialBanner[locale] + ')' , backgroundSize: 'cover', backgroundPosition : 'center', height : '80vh'}}>
        <Grid.Column style={styles.headerWrapper}>
          <Header as='h1' style={styles.header}>
            {string['trialPitchHeader']}
            <Header.Subheader style={styles.subheader}>{string['trialPitchSubHeader']}</Header.Subheader>
          </Header>
          <a id="freetrial" href="https://dashboard.kios.tech/auth/signup"><Button style={styles.appliedButton} size='massive'>{string['appliedFreeTrial']}</Button></a>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    locale : state.preference.locale,
    string : state.preference.string,
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(TrialPitch)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/trialPitch.js
 **/